module.exports = __webpack_public_path__ + "img/logo-apple.4497bcf8.png";